<template>
	<div class="AppNavBarV2" @click="closeModel($event)">
		<div class="s1">
			<div class="s1__left">
				<!-- <i
          class="el-icon-search  text-base"
        />
        <input
          type="text"
          class="s1__input"
          placeholder="Search..."

        > -->
				<div
					v-if="
						$route.name != 'NewDashboard' &&
						$route.name != 'ChildPages' &&
						$route.name != 'license-management' &&
						$route.name != 'salesForecastV2'
					"
					class="font-semibold text-base cursor-pointer flex items-center"
					style="font-size: 14px"
					@click="$router.go(-1)"
				>
					<img
						src="../../../assets/icons/Back Arrow.png"
						alt="back"
						width="27px"
						class="mr-1"
					/>
					Back
				</div>
				&nbsp;
			</div>
			<div class="s1__right">
				<div style="display: flex">
					<div class="notification-dropdown">
						<i
							class="el-icon-bell text-lg mr-8 cursor-pointer notif"
							@click="showNotficationDropdown"
						>
							<span
								v-if="unread_notify_count != 0"
								class="notification-tooltip"
							>
								{{ unread_notify_count }}
							</span>
						</i>
						<div
							v-if="show_notification_dropdown"
							id="notifiation-model"
							class="modal"
						>
							<div class="notification-dropdown-content">
								<div class="notify-header">
									<span style="font-weight: bold"> Notifications </span>
									<span
										style="float: right; color: #e29d5a; cursor: pointer"
										@click="markAllReadNotify()"
									>
										Mark All as Read
									</span>
								</div>
								<simplebar class="simplebar">
									<div
										v-for="(notification, index) in all_notifications"
										:key="index"
									>
										<div
											class="p-2 notify-data"
											:style="[
												!notification.unread
													? { background: '#ffffff' }
													: { background: '#edf2fa' },
											]"
											@click="expandNotification(notification.data)"
										>
											<div>
												<div class="mr-2" style="width: 100%">
													<div
														style="line-height: 1.2"
														class="text-wrapping"
														:title="notification.verb"
													>
														<span
															style="font-size: 0.9rem; vertical-align: middle"
															><i class="el-icon-bell"></i
														></span>
														&nbsp; <span>{{ notification.verb }}</span>
													</div>
												</div>
												<div class="date">
													<div>
														<i class="el-icon-time"></i>&nbsp;{{
															new Date(notification.timestamp).toDateString()
														}}
													</div>
													<div class="text-right">
														<el-checkbox
															v-model="notification.unread"
															:title="
																!notification.unread
																	? 'Mark as Unread'
																	: 'Mark as Read'
															"
															@change="
																updateMarkNofiy(
																	notification.id,
																	notification.unread
																)
															"
														/>
													</div>
												</div>
											</div>
										</div>
										<div
											v-if="all_notifications.length - 1 > index"
											class="faded-border-bottom"
										>
											&nbsp;
										</div>
									</div>
								</simplebar>
							</div>
						</div>
					</div>

					<!-- <a
						class="hover:text-amp-hover py-1 cursor-pointer text-xs"
						@click="
							() =>
								$router.push({ path: '/nymble-dashboard/item-master/' })
						"
					>
						Item Master
					</a>
					<a class="hover:text-amp-hover py-1 cursor-pointer text-xs">
						Sales Data
					</a>
					<a
						class="hover:text-amp-hover py-1 cursor-pointer text-xs"
						@click="
							() => $router.push({ path: '/nymble-dashboard/recipe/' })
						"
					>
						Bill of Material
					</a>
					<a
						class="hover:text-amp-hover py-1 cursor-pointer text-xs"
						@click="
							() => $router.push({ path: `/nymble-dashboard/supplier/` })
						"
					>
						Supplier
					</a> -->

					<!-- <div class="setting-dropdown" v-if="show_option && !isTheobroma">
						<i
							class="el-icon-setting text-lg cursor-pointer"
							@click="showSettingDropdown()"
						/>
						<div
							v-if="show_setting_dropdown"
							id="setting-dropdown-model"
							class="setting-modal"
						>
							<div class="setting-dropdown-content">
								<a
									v-if="isAdmin == 'admin'"
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="redirectToAccountSetup(), show_setting_dropdown= false"
								>
									Account Setup
								</a>
								<a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="$router.push({ name: 'StoreDetails' }), show_setting_dropdown= false"
								>
									Store Settings
								</a>
								<a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="$router.push({ name: 'EventList' }), show_setting_dropdown= false"
								>
									Events and Promotion
								</a>
								<a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="$router.push({ name: 'Targets' }), show_setting_dropdown= false"
								>
									Targets
								</a>
								<a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="$router.push({ name: 'Notifications' }), show_setting_dropdown= false"
								>
									Set Trigger
								</a>
							</div>
						</div>
					</div> -->

					<div v-if="show_option && !isTheobroma" class="setting-dropdown">
						<i
							class="el-icon-setting text-lg cursor-pointer"
							@click="showSettingDropdown()"
						/>
						<div
							v-if="show_setting_dropdown"
							id="setting-dropdown-model"
							class="setting-modal"
						>
							<div class="setting-dropdown-content">
								<a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									href="#"
									@click.prevent="
										() => {
											$router.push({ name: 'Company' }).catch(() => {});
											show_setting_dropdown = false;
										}
									"
								>
									Company Settings
								</a>
								<a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									href="#"
									@click.prevent="
										() => {
											$router.push({ name: 'Store' }).catch(() => {});
											show_setting_dropdown = false;
										}
									"
								>
									Store Settings
								</a>
							</div>
						</div>
					</div>
				</div>

				<div class="s1__nameDD">
					<div class="cursor-pointer" @click="showStoreDropdown()">
						<span class="mr-2 pl-8 border-l text-sm capitalize">
							{{ full_name }}
						</span>
						<i class="el-icon-arrow-down text-xs" />
					</div>
					<div v-if="show_dropdown" id="modal" class="modal">
						<div id="myDropdown" class="dropdown-content">
							<template v-if="!easyAsPataal">
								<!-- <a
								class="hover:text-amp-hover py-1 cursor-pointer text-xs"
								@click="routeToEditStoreData"
							>
								Edit Store Data
							</a> -->
								<!-- <a
								v-if="isAdmin == 'admin' && !isTheobroma"
								class="hover:text-amp-hover py-1 cursor-pointer text-xs"
								@click="redirectToUi('/locations')"
							>
								V2 Locations
							</a> -->
								<a
									v-if="isAdmin !== 'outlet'"
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="redirectToUi('/app-store-details')"
								>
									Locations
								</a>
								<!-- <a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="redirectToUi('/locations')"
								>
									Locations 
								</a> -->
								<!-- <a
								v-if="isAdmin == 'admin'"
								class="hover:text-amp-hover py-1 cursor-pointer text-xs"
								@click="redirectToUi('/user-groups')"
							>
								Users
							</a> -->
								<a
									v-if="
										isAdmin == 'admin' &&
										show_option &&
										!isTheobroma &&
										!isBKasia
									"
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="
										redirectToAccountSetup(), (show_setting_dropdown = false)
									"
								>
									Account Setup
								</a>
							</template>
							<a
								v-if="isAdmin == 'admin' && show_option"
								class="hover:text-amp-hover py-1 cursor-pointer text-xs"
								@click="redirectToUi('/account-information')"
							>
								Account Information
							</a>
							<template v-if="!easyAsPataal">
								<!-- <a
								v-if="show_option && !isTheobroma"
								class="hover:text-amp-hover py-1 cursor-pointer text-xs"
								@click="$router.push({ name: 'StoreDetails' }), show_setting_dropdown= false"
							>
								Store Settings
							</a> -->
								<!-- <a
								class="hover:text-amp-hover py-1 cursor-pointer text-xs"
								@click="openUploadCSVDialog()"
							>
								Store Details
							</a> -->
								<!-- v-if="full_name" -->
								<!-- <a
									v-if="!is_sb_malaysia"
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="
										$router.push({ name: 'EventList' }).catch(() => {});
										show_setting_dropdown = false;
									"
								>
									Events and Promotion
								</a> -->
								<a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="
										is_demo
											? redirectToUi('/support-v2')
											: redirectToUi('/support')
									"
								>
									Support
								</a>
								<a
									class="hover:text-amp-hover py-1 cursor-pointer text-xs"
									@click="redirectToUi('/videos')"
								>
									Videos
								</a>
							</template>
							<a
								class="hover:text-amp-hover py-1 cursor-pointer text-xs"
								@click="logout()"
							>
								Logout
							</a>
						</div>
					</div>
				</div>
				<el-dialog
					title
					:visible.sync="dialogVisible"
					:before-close="closeDialog"
					:close-on-click-modal="false"
				>
					<AppUploadCsvOrAddStoreDetails @hide-popup="dialogVisible = false" />
				</el-dialog>
				<el-dialog
					title="Errors in Csv File"
					:visible.sync="errosDialogVisible"
					:fullscreen="true"
					:before-close="closeErrorsDialog"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
				>
					<el-table :data="errorsInCsv">
						<el-table-column property="row" label="ROW" width="150" />
						<el-table-column property="column" label="COLUMN" width="200" />
						<el-table-column property="details" label="DETAILS" />
					</el-table>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
import AppUploadCsvOrAddStoreDetails from "../appUploadCsvOrAddStoreDetails/appuploadCsvOrAddStoreDetails.vue";
import { serverAddr } from "../../../networkConfig";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import { EventBus } from "../../../eventBus";
import { mapState } from "vuex";
export default {
	name: "AppNavBarV2",
	components: { AppUploadCsvOrAddStoreDetails, simplebar },
	data() {
		return {
			dialogVisible: false,
			errosDialogVisible: false,
			show_dropdown: false,
			show_setting_dropdown: false,
			show_store_dialog: false,
			full_name: "",
			show_notification_dropdown: false,
			all_notifications: [],
			unread_notify_count: null,
			errorsInCsv: [],
			isAdmin: "",
			user_id: "",
			email: "",
			show_option: true,
			is_sb_malaysia: false,
		};
	},
	computed: {
		...mapState("CommonStore", ["companyData"]),
		// showUploadCSVDialog() {
		// 	// Whenever $store.state.show_login_and_freeTrial_model changes, it will cause the computed property to re-evaluate, and trigger associated DOM updates.
		// 	return this.$store.state.upload_csv_dialog;
		// }
		isKFC() {
			let localData = localStorage.getItem("check_company");
			localData = JSON.parse(localData);
			return localData.is_kfc;
		},
		isTheobroma() {
			if (
				(this.email &&
					this.email.toLowerCase().indexOf("@theobroma.in") !== -1) ||
				this.email.toLowerCase().includes("theobroma")
			) {
				return true;
			} else {
				return false;
			}
		},
		isBKasia() {
			if (this.email && "bkasia@nymbleup.com") {
				return true;
			} else {
				return false;
			}
		},
		easyAsPataal() {
			if (this.companyData.name == "Easy Aspataal") {
				return true;
			} else {
				return false;
			}
		},
	},
	created() {
		this.isAdmin = localStorage.getItem("user_access_level");
		if (window.localStorage.getItem("errorsInCsv") !== null) {
			this.errorsInCsv = JSON.parse(window.localStorage.getItem("errorsInCsv"));
			this.errosDialogVisible = true;
		}

		this.getUnReadNotifyCount();
		this.getUserNotifications();
		var user_info = "";
		user_info = this.$store.state.loginUserDetails;
		if (user_info && Object.keys(user_info).length != 0) {
			this.full_name = user_info.full_name;
		} else {
			serverAddr
				.get("/users/self/", {})
				.then((res) => {
					this.$store.commit("getUserDetails", JSON.parse(res.data));
					user_info = this.$store.state.loginUserDetails;
					this.full_name = user_info.full_name;
					localStorage.setItem("user_id", user_info.id); //stored user name for show sub dropdown in side bar
					this.user_id = localStorage.getItem("user_id"); //stored user name for show sub dropdown in side bar
				})
				.catch((error) => {
					this.$notify.error({
						title: "fail",
						message: JSON.parse(error.response.data).name[0],
					});
				});
		}
	},
	mounted() {
		this.is_sb_malaysia =
			localStorage.getItem("company_id") ==
			"15e1f09e-acdb-43de-8009-db3e1bb5c1a1"
				? true
				: false;
		EventBus.$on("hideSetting", (data) => {
			this.hideSettingDropdown();
			// console.log("graph", data);
		});
		EventBus.$on("logout_user", function (payload) {
			this.logout();
		});
		this.email = localStorage.getItem("user_email");
		this.checkUserAuth();
	},
	methods: {
		checkUserAuth() {
			if (
				this.email == "tushar.shinde@wellnessforever.in" ||
				this.email == "gokuldas.gawade@wellnessforever.in" ||
				this.email == "safiahmad.khan@wellnessforever.in" ||
				this.email == "ratnesh.maurya@wellnessforever.in" ||
				this.email == "amar.soni@wellnessforever.in" ||
				this.email == "rkhan@burgerking.in" ||
				this.email == "vdhanuka@burgerking.in" ||
				this.email == "ukhemka@burgerking.in" ||
				this.email == "ssinha@burgerking.in" ||
				this.email == "ntiwari@burgerking.in"
			) {
				this.show_option = false;
			} else {
				this.show_option = true;
			}
		},
		redirectToAccountSetup() {
			this.$router.push({ path: "/account-setup" }).catch(() => {});
		},
		expandNotification(data) {
			// console.log(data);
			if (data && data.data.type === "error") {
				console.log(data.data.details);
				window.localStorage.setItem(
					"errorsInCsv",
					JSON.stringify(data.data.details)
				);

				window.open(this.$route.path, "_blank");
			}
		},
		closeErrorsDialog() {
			this.errosDialogVisible = false;
			window.localStorage.removeItem("errorsInCsv");
			EventBus.$emit("resetCsvVariablesEvent");
		},
		routeToEditStoreData() {
			this.$router.push({ name: "AccountSetup" }).catch(() => {});
			this.show_dropdown = false;
		},
		closeDialog() {
			this.dialogVisible = false;
			// this.$store.commit("uploadCSVDialog", false);
		},
		showStoreDropdown() {
			this.show_dropdown = true;
			// console.log(this.show_dropdown);
		},
		hideStoreDropdown() {
			this.show_dropdown = false;
			// console.log("hide", this.show_dropdown);
		},
		showSettingDropdown() {
			this.show_setting_dropdown = true;
		},
		hideSettingDropdown() {
			this.show_setting_dropdown = false;
		},
		showNotficationDropdown() {
			this.show_notification_dropdown = true;
		},
		hideNotficationDropdown() {
			this.show_notification_dropdown = false;
		},
		openUploadCSVDialog() {
			this.dialogVisible = true;
			// this.show_store_dialog = true;
			// this.$store.commit("uploadCSVDialog", true);
		},
		redirectToUi(url) {
			this.show_dropdown = false;
			this.$router.push(url).catch(() => {});
		},
		logout() {
			const r_email = localStorage.getItem("r_email");
			localStorage.clear();
			if (r_email) {
				localStorage.setItem("r_email", r_email);
			}
			// window.localStorage.setItem("x-access-token", null);
			// window.localStorage.setItem("x-refresh-token", null);
			// window.localStorage.setItem("store", "");
			// window.localStorage.setItem("user_access_level", null);
			// window.localStorage.setItem("loglevel:webpack-dev-server", null);
			// localStorage.removeItem("username");
			this.$store.commit("getUserDetails", {});
			document.getElementById("app").style.marginLeft = "0";

			this.$router.push("/").catch(() => {});
		},
		getUnReadNotifyCount() {
			serverAddr
				.get("/users/notifications/unread/count/")
				.then((res) => {
					var response = JSON.parse(res.data);
					this.unread_notify_count = response.unread_count;
				})
				.catch((error) => {
					console.log("error", error);
				});
		},
		getUserNotifications() {
			serverAddr
				.get("/users/notifications/")
				.then((res) => {
					var response = JSON.parse(res.data);
					this.all_notifications = response.results;
				})
				.catch((error) => {
					console.log("error", error);
				});
		},
		markAllReadNotify() {
			serverAddr
				.post("/users/notifications/read/", {})
				.then((res) => {
					this.$notify.success({
						title: "Success",
						message: JSON.parse(res.data).message,
					});
					this.all_notifications = [];
					this.getUnReadNotifyCount();
					this.getUserNotifications();
				})
				.catch((error) => {
					console.log("error", error);
				});
		},
		updateMarkNofiy(seleted_id, status) {
			// console.log("read_status", seleted_id, status);
			var read_mode = "unread";
			if (!status) {
				read_mode = "read";
			}
			serverAddr
				.post(`/users/notifications/${seleted_id}/${read_mode}/`)
				.then((res) => {
					this.$notify.success({
						title: "Success",
						message: JSON.parse(res.data).message,
					});
					this.all_notifications = [];
					this.getUnReadNotifyCount();
					this.getUserNotifications();
				})
				.catch((error) => {
					console.log("error", error);
				});
		},
		closeModel(event) {
			var modal = document.getElementById("modal");
			var notification_modal = document.getElementById("notifiation-model");
			var setting_modal = document.getElementById("setting-dropdown-model");
			if (event.target == modal) {
				this.hideStoreDropdown();
			}
			if (event.target == notification_modal) {
				this.hideNotficationDropdown();
			}
			if (event.target == setting_modal) {
				this.hideSettingDropdown();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
@import "./AppNavBarV2.scss";
</style>

<style lang="scss" scoped>
.setting-dropdown a {
	text-decoration: none;
	color: #a3a4a6;
}
</style>
